"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/09/04
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPort = set;
exports.getPort = getPort;
exports.sendMessage = sendMessage;
const tslib_1 = require("tslib");
const logger_1 = tslib_1.__importDefault(require("../logger"));
const receive_1 = require("./receive");
const ask_1 = require("./ask");
const internalState = {
    askInitialisation: false,
    lastRetry: 0,
    port: undefined,
    retryCount: 0,
    storedMessages: [],
};
function set(newPort) {
    internalState.port = newPort;
    if (internalState.port) {
        // set the message listener; this is wrapped in the `if` for testing
        internalState.port.onmessage = receive_1.onMessageListener;
    }
}
function getPort() {
    return internalState.port;
}
function retry() {
    if (internalState.port) {
        internalState.retryCount = 0;
        while (internalState.storedMessages.length > 0) {
            const storedMsg = internalState.storedMessages.shift();
            if (storedMsg) {
                sendMessage(storedMsg.data, storedMsg.transferables);
            }
        }
    }
    else {
        const now = Date.now();
        if (internalState.lastRetry === 0 || now - 900 > internalState.lastRetry) {
            internalState.lastRetry = now;
            internalState.retryCount += 1;
            if (internalState.retryCount < 7) {
                setTimeout(retry, 1000);
            }
            else {
                if (internalState.askInitialisation) {
                    // once we asked for initialisation, we will not retry anymore
                    logger_1.default.error("retrying setup & initialisation failed");
                }
                else {
                    internalState.askInitialisation = true;
                    (0, ask_1.askInitialisation)();
                    logger_1.default.error("retrying setup failed");
                }
            }
        }
    }
}
function sendMessage(data, transferables) {
    if (internalState.port) {
        retry();
        // Use transferable objects if provided
        if (transferables && transferables.length > 0) {
            internalState.port.postMessage(data, transferables);
        }
        else {
            internalState.port.postMessage(data);
        }
    }
    else {
        internalState.storedMessages.push({ data, transferables });
        setTimeout(retry, 1000);
    }
}
//# sourceMappingURL=port.js.map